import { useEffect, useState } from "react";

import { API_STATES } from "models/new/helpers";
import { TAPIResponse } from "models/new/types";
import { TMerchantEnablementCompany } from "./merchant-enablements.type";
import { fetch, fetchJSON } from "lib/fetch";

type TUpsertCompanyResponse = {
    company: TMerchantEnablementCompany;
};

export type TParams = {
    enabled: boolean;
    brandID: string;
    company?: TMerchantEnablementCompany;
    body: {
        company: {
            name: string;
        };
    };
};

interface IUpsertCompany<Params, Response> {
    (params: Params): Response;
}

export const useUpsertCompany: IUpsertCompany<TParams, any> = (params) => {
    const [state, setState] = useState<TAPIResponse<TUpsertCompanyResponse, string>>(API_STATES.default);

    const APIStates = API_STATES.getStates(setState);

    useEffect(() => {
        if (params.enabled) {
            APIStates.pending();

            if (params.company && params.company.name === params.body.company.name) {
                setState({
                    data: { company: params.company },
                    error: null,
                    loaded: true,
                    isLoading: false,
                });

                return;
            }

            if (params.company) {
                fetch(
                    `/lightspeed-b2b/api/v1/merchant-enablement/brands/${params.brandID}/companies/${params.company.id}`,
                    {
                        method: "PUT",
                        body: JSON.stringify(params.body),
                        noDomain: false,
                    }
                )
                    .then((_) => APIStates.success({ company: { ...params.company, name: params.body.company.name } }))
                    .catch(APIStates.error);

                return;
            }

            fetchJSON<TUpsertCompanyResponse>(
                `/lightspeed-b2b/api/v1/merchant-enablement/brands/${params.brandID}/companies`,
                {
                    method: "POST",
                    body: JSON.stringify(params.body),
                    noDomain: false,
                }
            )
                .then(APIStates.success)
                .catch(APIStates.error);
        } else {
            // Ensures that the action can be triggerd multiple times.
            setState(API_STATES.default);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.enabled]);

    return state;
};
